const config = {
  API_BASE_URL: "https://dev.fusioncab.com",
  RAZORPAY_KEY_ID: "rzp_test_l26UI19jahS4X8",
  RAZORPAY_KEY_SECRET: "QgiblRJh2h3jBfcWvrSIeLpn",
  API_VERSION: "/app/v1",
  ENDPOINTS: {
    AUTH: "/app/v1/user/auth",
    PUBLIC: "/app/v1/user/public",
    BOOKING: "/app/v1/user/booking",
    PAYMENT: "/app/v1/user/payment",
  },
  TOKEN_STORAGE_KEY: "fusioncab_access_token",
  REFRESH_TOKEN_STORAGE_KEY: "fusioncab_refresh_token",
  USER_STORAGE_KEY: "fusioncab_user",
  
};

export default config;
